import { FC, useRef } from "react";
import { Form, FormikProvider } from "formik";
import {
    StandardModalBody,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { StepsRef } from "@design-system/Steps";
import { useKeyboardCommand } from "@hooks/keyboard/useKeyboardCommand";
import actionsStyles from "../ClientActions.module.scss";
import { AddClientSteps } from "./AddClientSteps/lib";
import { AddClientStepsContainer } from "./AddClientStepsContainer";
import { useAddClientForm } from "./useAddClientForm";

interface Props {
    onClose: () => void;
}

export const AddClientModal: FC<Props> = ({ onClose }) => {
    const stepsRef = useRef<StepsRef>(null);
    const {
        formik,
        loadingAction,
        currentStep,
        handleStepChange,
        submitWithoutInvite,
    } = useAddClientForm({ onClose, multiEntityFlow: false });

    useKeyboardCommand({
        keys: "enter",
        callback: () => {
            if (
                [
                    AddClientSteps.INVITE,
                    AddClientSteps.BILLING_TRANSFER,
                ].includes(currentStep)
            ) {
                formik.submitForm();
            } else {
                stepsRef.current?.next();
            }
        },
        options: { description: "Submit form" },
    });

    return (
        <>
            <StandardModalHeader className={actionsStyles.modalHeader}>
                Add client
            </StandardModalHeader>
            <StandardModalBody className={actionsStyles.modalBody}>
                <FormikProvider value={formik}>
                    <Form>
                        <AddClientStepsContainer
                            currentStep={currentStep}
                            handleStepChange={handleStepChange}
                            loadingAction={loadingAction}
                            submitWithoutInvite={submitWithoutInvite}
                        />
                    </Form>
                </FormikProvider>
            </StandardModalBody>
        </>
    );
};
